import React from "react";
import { useEditor, useSmartProp } from "@smartfire/gutenberg-react";
import { RichText } from '@wordpress/block-editor';

export const Menu = props => {
    const { smartProp } = props;
    const { isEditing } = useEditor();
    const [menusCustom, setMenusCustom] = useSmartProp(smartProp);

    function updateValue (key, value, i) {
        let copy = [...menusCustom];
        copy[i][key] = value;
        setMenusCustom(copy)
    }

    const addElement = () => {
        let newElement = {
            tag: '',
        }
        setMenusCustom([...menusCustom, newElement]);
    }

    const deletElement = (i) => {
        let copy = [...menusCustom];
        copy.splice(i, 1);
        setMenusCustom(copy);
    }

    return <div smartProp={smartProp}>
        {isEditing ? <>
            {menusCustom && menusCustom.map((el, index) => (
                <div key={index}>
                    <button onClick={() => deletElement(index)}>
                        <svg className="dashicon dashicons-trash" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                            <path d="M12 4h3c.6 0 1 .4 1 1v1H3V5c0-.6.5-1 1-1h3c.2-1.1 1.3-2 2.5-2s2.3.9 2.5 2zM8 4h3c-.2-.6-.9-1-1.5-1S8.2 3.4 8 4zM4 7h11l-.9 10.1c0 .5-.5.9-1 .9H5.9c-.5 0-.9-.4-1-.9L4 7z"></path>
                        </svg>
                    </button>
                    <RichText
                        tagName="div"
                        placeholder={'Titre'}
                        allowedFormats={"core/link"}
                        value={el.tag}
                        onChange={(value) => updateValue('tag', value, index)}
                    />
                </div>
            ))}
            <button onClick={() => addElement()}>
                <svg className="dashicon dashicons-insert" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                    <path d="M10 1c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7zm1-11H9v3H6v2h3v3h2v-3h3V9h-3V6z"></path>
                </svg>
            </button>
        </> : 
        <ul>
            {menusCustom && menusCustom.map((el, index) => (
                <li key={index} dangerouslySetInnerHTML={{__html: el.tag}} />
            ))}
        </ul>
        }
    </div>
}